import React from "react";
import logo from "../Images/about1.jpg";
import logo2 from "../Images/about 2.jpg";
import backgroundImg from "../Images/aboutbackground.jpg";

const About = () => {
  return (
    <>
      <div
        className="container-fluid d-flex align-items-center flex-column mb-5"
        style={{
          padding: "20px",
        }}
      >
        <div
          className="row w-100 align-items-center"
          style={{ backgroundColor: "#e2ab77" }}
        >
          <div className="col-md-6">
            <img
              src={logo}
              className="img-fluid"
              style={{ objectFit: "cover", maxHeight: "100%" }}
              alt="Description of your image"
            />
          </div>
          <div className="col-md-6">
            <div style={{ padding: "10px" }}>
              <h1 className="text-danger" style={{ fontSize: "2.5em" }}>
                About Website!
              </h1>
              <p style={{ fontSize: "1.2em", textAlign: "justify" }}>
                A patent registration website facilitates the legal protection
                of inventions. Users can submit their innovative ideas, designs,
                or processes for review by patent offices. The platform guides
                applicants through the registration process, offering resources
                and documentation support. It streamlines communication with
                patent examiners, ensuring a comprehensive understanding of the
                submission. Additionally, these websites often provide updates
                on patent laws and regulations. Overall, a patent registration
                website serves as a centralized hub, promoting efficiency in
                securing intellectual property rights and fostering innovation
                in various industries.
              </p>
            </div>
          </div>
        </div>
        <div
          className="row w-100 align-items-center"
          style={{ marginTop: "15px", width: "100%" }}
        >
          <div
            className="col-md-12 "
            style={{ padding: "20px", border: "2px solid #e2ab77" }}
          >
            <img
              src={logo2}
              className="img-fluid"
              style={{
                objectFit: "cover",
                maxHeight: "500px",
                width: "2700px",
              }}
              alt="Description of your other image"
            />

            <p
              style={{
                fontSize: "1.5em",
                paddingTop: "30px",
                PaddingBottom: "30px",
              }}
            >
              <ul style={{ textAlign: "justify" }}>
                <li>
                  A patent registration website serves as a crucial platform for
                  individuals and businesses seeking to protect their
                  intellectual property. The process of obtaining a patent can
                  be complex, involving legal intricacies and documentation.
                  These websites streamline and simplify this process, offering
                  a user-friendly interface to guide applicants through each
                  step.
                </li>
                <br />
                <li>
                  One key feature of these platforms is the provision of
                  comprehensive information about patent laws and regulations.
                  This educational aspect ensures that users are well-informed
                  about the requirements and implications of obtaining a patent.
                  From outlining patentable subject matter to explaining the
                  novelty and non-obviousness criteria, these websites act as
                  valuable resources for both novice inventors and seasoned
                  innovators.
                </li>
                <br />
                <li>
                  The registration process itself is often facilitated through
                  intuitive online forms, minimizing the administrative burden
                  on applicants. Clear instructions and prompts guide users in
                  providing the necessary details about their invention,
                  ensuring that the patent application is complete and adheres
                  to legal standards. Some platforms even offer real-time
                  assistance through chat support or FAQs, further enhancing the
                  user experience.
                </li>
                <br />
                <li>
                  Furthermore, these websites typically provide a secure and
                  centralized repository for storing patent-related documents.
                  This not only ensures easy access for applicants but also
                  contributes to the transparency and accountability of the
                  patent system.
                </li>
                <br />
                <li>
                  In terms of efficiency, patent registration websites often
                  incorporate digital tools to expedite the examination process.
                  Electronic filing systems, status tracking, and notifications
                  keep applicants informed about the progress of their patent
                  applications. This accelerates the overall timeline, enabling
                  inventors to secure their intellectual property rights more
                  promptly.
                </li>
                <br />
                <li>
                  Overall, patent registration websites play a pivotal role in
                  democratizing access to the patent system. By offering
                  user-friendly interfaces, educational resources, and digital
                  tools, these platforms empower innovators to navigate the
                  complex landscape of intellectual property protection with
                  greater ease and efficiency.
                </li>
                <br />
              </ul>
            </p>
          </div>
        </div>
        <div
          style={{
            background: `url(${backgroundImg})`,
            padding: "40px",
            marginTop: "40px",
            color: "white",
          }}
        >
          <h1 className="text-info" style={{ textAlign: "center" }}>
            Rules for Patent Registration
          </h1>
          <br />
          <ol style={{ fontSize: "1.5em", textAlign: "justify" }}>
            <li>
              <strong>Novelty:</strong> The invention or innovation seeking
              patent protection must be novel, meaning it should not have been
              previously disclosed or made available to the public before the
              patent application filing date.
            </li>
            <br />
            <li>
              <strong>Non-Obviousness:</strong> The invention must not be
              obvious to a person with ordinary skill in that field. It should
              represent a significant improvement or departure from existing
              technologies or methods.
            </li>
            <br />
            <li>
              <strong>Usefulness/Utility:</strong> The invention should have a
              practical application. It should serve a useful purpose and have
              some form of utility.
            </li>
            <br />
            <li>
              <strong>Disclosure:</strong> Full disclosure of the invention is
              essential. This includes providing a detailed description and any
              necessary diagrams or drawings, enabling someone skilled in the
              field to reproduce or use the invention.
            </li>
            <br />
            <li>
              <strong>Patent Application:</strong> Filing a patent application
              with the relevant patent office is necessary. The application
              includes a detailed description of the invention, claims defining
              the scope of protection sought, and often accompanying
              illustrations.
            </li>
            <br />
            <li>
              <strong>Examination:</strong> The patent office will conduct an
              examination to verify if the invention meets the patentability
              criteria. This examination involves a review of prior art and a
              determination of whether the invention qualifies for patent
              protection.
            </li>
            <br />
            <li>
              <strong>Grant and Maintenance:</strong> If the patent office
              determines that the invention meets all requirements, a patent
              will be granted. Maintenance fees or annuities may be required
              periodically to keep the patent in force.
            </li>
            <br />
            <li>
              <strong>Duration:</strong> Patents typically have a limited
              duration of protection, usually around 20 years from the date of
              filing the application, after which they expire, and the invention
              enters the public domain.
            </li>
            <br />
          </ol>
        </div>
      </div>
    </>
  );
};

export default About;
